import api from '../interceptors/axiosInterceptor'
import API_CONFIG from '../config'

const PAYMENT_ENDPOINTS = {
  // درگاه‌های پرداخت
  GATEWAYS: '/payment/gateways',
  ACTIVE_GATEWAYS: '/payment/gateways/active',
  
  // پرداخت‌ها
  INITIATE: '/payment/initiate',
  VERIFY: '/payment/verify',
  GET_ALL: '/payments',
  GET_BY_ID: '/payments',        // /payments/{id}
  GET_BY_ORDER: '/payments/order', // /payments/order/{orderId}
  MY_PAYMENTS: '/payments/my',
  
  // تراکنش‌ها
  TRANSACTIONS: '/payment/transactions',
  TRANSACTION_DETAIL: '/payment/transactions', // /payment/transactions/{id}
  
  // بازپرداخت‌ها
  REFUND: '/payment/refund',
  REFUND_STATUS: '/payment/refund/status', // /payment/refund/status/{refundId}
  
  // کارت‌های بانکی
  CARDS: '/payment/cards',
  ADD_CARD: '/payment/cards',
  DELETE_CARD: '/payment/cards', // /payment/cards/{cardId}
  DEFAULT_CARD: '/payment/cards/default', // /payment/cards/{cardId}/default
  
  // کیف پول
  WALLET: '/payment/wallet',
  WALLET_BALANCE: '/payment/wallet/balance',
  WALLET_TRANSACTIONS: '/payment/wallet/transactions',
  WALLET_CHARGE: '/payment/wallet/charge',
  WALLET_WITHDRAW: '/payment/wallet/withdraw',
  
  // کوپن و تخفیف
  COUPONS: '/payment/coupons',
  VALIDATE_COUPON: '/payment/coupons/validate',
  APPLY_COUPON: '/payment/coupons/apply',
  
  // صورتحساب
  INVOICES: '/payment/invoices',
  INVOICE_DETAIL: '/payment/invoices', // /payment/invoices/{id}
  DOWNLOAD_INVOICE: '/payment/invoices/download', // /payment/invoices/{id}/download
  
  // آمار
  STATS: '/payment/stats',
  DAILY_REVENUE: '/payment/stats/daily-revenue'
}

const PaymentService = {
  // دریافت درگاه‌های پرداخت
  async getGateways() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.GATEWAYS}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت درگاه‌های فعال
  async getActiveGateways() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.ACTIVE_GATEWAYS}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // شروع فرآیند پرداخت
  async initiatePayment(paymentData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.INITIATE}`,
        paymentData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // تایید پرداخت
  async verifyPayment(transactionId, authority) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.VERIFY}`,
        { transactionId, authority }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت همه پرداخت‌ها (ادمین)
  async getAllPayments(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.GET_ALL}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت پرداخت توسط ID
  async getPaymentById(paymentId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.GET_BY_ID}/${paymentId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت پرداخت‌های یک سفارش
  async getPaymentByOrder(orderId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.GET_BY_ORDER}/${orderId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت پرداخت‌های کاربر
  async getMyPayments(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.MY_PAYMENTS}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت تراکنش‌ها
  async getTransactions(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.TRANSACTIONS}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت جزئیات تراکنش
  async getTransactionDetail(transactionId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.TRANSACTION_DETAIL}/${transactionId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // درخواست بازپرداخت
  async requestRefund(refundData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.REFUND}`,
        refundData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بررسی وضعیت بازپرداخت
  async getRefundStatus(refundId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.REFUND_STATUS}/${refundId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // مدیریت کارت‌های بانکی
  async getSavedCards() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.CARDS}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async addCard(cardData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.ADD_CARD}`,
        cardData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async deleteCard(cardId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.DELETE_CARD}/${cardId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async setDefaultCard(cardId) {
    try {
      const response = await api.patch(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.DEFAULT_CARD}/${cardId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // مدیریت کیف پول
  async getWalletInfo() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.WALLET}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async getWalletBalance() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.WALLET_BALANCE}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async getWalletTransactions(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.WALLET_TRANSACTIONS}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async chargeWallet(amount, gateway = 'zarinpal') {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.WALLET_CHARGE}`,
        { amount, gateway }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async withdrawFromWallet(amount, bankAccount) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.WALLET_WITHDRAW}`,
        { amount, bankAccount }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // مدیریت کوپن‌ها
  async getCoupons(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.COUPONS}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async validateCoupon(code) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.VALIDATE_COUPON}`,
        { code }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async applyCoupon(orderId, couponCode) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.APPLY_COUPON}`,
        { orderId, couponCode }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // مدیریت صورتحساب‌ها
  async getInvoices(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.INVOICES}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async getInvoiceDetail(invoiceId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.INVOICE_DETAIL}/${invoiceId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async downloadInvoice(invoiceId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.DOWNLOAD_INVOICE}/${invoiceId}`,
        { responseType: 'blob' }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // آمار پرداخت‌ها
  async getPaymentStats(timeRange = 'month') {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.STATS}`,
        { params: { range: timeRange } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async getDailyRevenue(startDate, endDate) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${PAYMENT_ENDPOINTS.DAILY_REVENUE}`,
        { params: { startDate, endDate } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // درگاه‌های پرداخت ایرانی
  getIranianGateways() {
    return [
      { id: 'zarinpal', name: 'زرین‌پال', isActive: true },
      { id: 'mellat', name: 'ملت', isActive: true },
      { id: 'saman', name: 'سامان', isActive: true },
      { id: 'parsian', name: 'پارسیان', isActive: true },
      { id: 'pasargad', name: 'پاسارگاد', isActive: true },
      { id: 'sadad', name: 'سداد', isActive: false }
    ]
  },

  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data.message || 'خطا در پرداخت',
        status: error.response.status,
        data: error.response.data
      }
    }
    // ... مشابه قبلی
  }
}

export default PaymentService